import CustomStore from 'devextreme/data/custom_store'
import teacherServices from 'app/services/pages/security/teacherServices/teacherServices'

/**
 * DevExtreme CustomStore for teacher lookup/list: each caller passes its own includeIds
 * (primary vs additional) so search results are not merged across editors.
 */
export function createTeacherLookupCustomStore({
    getIncludeIds,
    loadCacheRef,
    loadInFlightRef,
    getHandleError,
}) {
    return new CustomStore({
        key: 'id',
        load: async (loadOptions) => {
            const searchTerm = (loadOptions.searchValue || '').toString().trim()
            const includeIds = getIncludeIds()
            const cacheKey = `${searchTerm.toLowerCase()}\0${includeIds.join(',')}`

            const cached = loadCacheRef.current.get(cacheKey)
            if (cached) return cached

            let inflight = loadInFlightRef.current.get(cacheKey)
            if (!inflight) {
                inflight = (async () => {
                    try {
                        const rows = await teacherServices.getTeacherLookupList({
                            firstName: searchTerm || undefined,
                            includeIds,
                        })
                        const list = Array.isArray(rows) ? rows : []
                        loadCacheRef.current.set(cacheKey, list)
                        return list
                    } catch (error) {
                        getHandleError()(error)
                        return []
                    } finally {
                        loadInFlightRef.current.delete(cacheKey)
                    }
                })()
                loadInFlightRef.current.set(cacheKey, inflight)
            }
            return await inflight
        },
        byKey: async (key) => {
            if (key == null || key === '') return null
            const k = String(key)
            try {
                return await teacherServices.getTeacherById(k)
            } catch (error) {
                getHandleError()(error)
                return { id: k, firstName: '', lastName: '' }
            }
        },
        errorHandler: (e) => console.error(e),
    })
}
